<template>
  <div  v-if="consulta" class="func-53">
    <div class="func-53">
      <funcionalidade-header :titulo="'Pendências'" :customVoltar="true" @click="back"></funcionalidade-header>
      <div id="detalhe-consulta">
        <el-row>
          <el-col :span="14">
            <div class="detalhes">
              <span style="margin-bottom: 10px" class="text-g-bold">Contato Responsável</span>
              <el-card class="detalhes-card">
                <span class="bold">{{consulta.meeting.responsavelAtendimento.nome}}</span>
                <span class="contatos" style="margin-top:5px"><svgIcone icone="Dash_whatsapp" :height="15" style="vertical-align: bottom;" :cor="'#CCCCCC'"/> {{consulta.meeting.responsavelAtendimento.contato.telefone}}</span>
                <span class="contatos" style="margin-top:5px"><svgIcone icone="icon_mini_email" :height="15" style="vertical-align: bottom;" :cor="'#CCCCCC'" /> {{consulta.meeting.responsavelAtendimento.contato.email}}</span>
              </el-card>
              <el-row>
                <el-col :span="2">
                  <svgIcone icone="icon_mini_info" :height="36" style="vertical-align: middle;" :cor="'#E8AA00'" />
                </el-col>
                <el-col :span="20">
                  <span style="font-size: 12px;"><b>{{ consulta.meeting.responsavelAtendimento.nome }}</b> é seu contato responsável por receber a chamada da teleconsulta em seu dispositivo e precisa resolver as seguintes pendências:</span>
                </el-col>
              </el-row>
              <span style="margin-top:25px; margin-bottom: 10px" class="text-g-bold">Pendências</span>
              <el-card class="detalhes-card-pendencias">
                <div style="display: flex; align-items: center; justify-content: center;" @click="gotoInstalarApp()">
                  <el-col :span="23">
                    <span class="bold">{{ funcionalidade.parametros.textos.tituloBoxPendenciaInstalarApp }}</span>
                    <span class="pendencia">{{ funcionalidade.parametros.textos.textoBoxPendenciaInstalarApp }}</span>
                    <el-button class="button-resolver">COMO RESOLVER?</el-button>
                  </el-col>
                  <el-col :span="1">
                    <div style="height: 20px;">
                      <i class="el-icon-arrow-right" style="font-size: 16px; font-weight: bold;"></i>
                    </div>
                  </el-col>
                </div>
              </el-card>
              <el-card class="detalhes-card-pendencias">
                <div style="display: flex; align-items: center; justify-content: center;" @click="gotoPermissoesApp()">
                  <el-col :span="23">
                    <span class="bold">{{ funcionalidade.parametros.textos.tituloBoxPendenciaAtivarMicrofoneCamera }}</span>
                    <span class="pendencia">{{ funcionalidade.parametros.textos.textoBoxPendenciaAtivarMicrofoneCamera }}</span>
                    <el-button class="button-resolver">COMO RESOLVER?</el-button>
                  </el-col>
                  <el-col :span="1">
                    <div style="height: 20px;">
                      <i class="el-icon-arrow-right" style="font-size: 16px; font-weight: bold;"></i>
                    </div>
                  </el-col>
                </div>
              </el-card>
              <el-card class="detalhes-card-pendencias">
                <div style="display: flex; align-items: center; justify-content: center;" @click="gotoNotificacoes()">
                  <el-col :span="23">
                    <span class="bold">{{ funcionalidade.parametros.textos.tituloBoxPendenciaAtivarNotificacoes }}</span>
                    <span class="pendencia">{{ funcionalidade.parametros.textos.textoBoxPendenciaAtivarNotificacoes }}</span>
                    <el-button class="button-resolver">COMO RESOLVER?</el-button>
                  </el-col>
                  <el-col :span="1">
                    <div style="height: 20px;">
                      <i class="el-icon-arrow-right" style="font-size: 16px; font-weight: bold;"></i>
                    </div>
                  </el-col>
                </div>
              </el-card>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
import FuncionalidadeHeader from '@/components/FuncionalidadeHeader/FuncionalidadeHeader.vue'
import { mapState } from 'vuex'

export default {
  components: { FuncionalidadeHeader },
  data () {
    return {
      consulta: null
    }
  },
  computed: {
    ...mapState('SetupApp', ['apiFuncionalidade', 'funcionalidade']),
    contatos () {
      return this.consulta.paciente.contatos
    }
  },
  methods: {
    async getDetalhe () {
      const res = await this.apiFuncionalidade.detalheConsulta({
        payload: {
          idAgenda: this.$route.query.idAgenda
        }
      })
      this.consulta = res.data
    },
    back () {
      this.$router.push({ path: '/53/detalhe', query: { consulta: this.consulta } })
    },
    gotoInstalarApp () {
      this.$router.push({ path: '/53/PendenciaInstalarOApp', query: { idAgenda: this.consulta.idAgenda } })
    },
    gotoPermissoesApp () {
      this.$router.push({ path: '/53/PendenciaPermissoes', query: { idAgenda: this.consulta.idAgenda } })
    },
    gotoNotificacoes () {
      this.$router.push({ path: '/53/PendenciaNotificacoes', query: { idAgenda: this.consulta.idAgenda } })
    },
    async init () {
      await this.getDetalhe()
    }
  },
  async created () {
    await this.init()
  }
}
</script>
<style>
#detalhe-consulta .detalhes-card-pendencias {
  background-color: #ecf6fc;
  border: none;
  border-radius: 6px;
  -webkit-box-shadow: none;
  box-shadow: none;
}
#detalhe-consulta .pendencia {
  display: block;
  font-size: 14px;
  padding: 10px 0;
}
.bold {
  font-family: "Open Sans", SansSerif;
  color: #333333;
  opacity: 1;
  font-weight: 600;
  font-size: 16px;
}
.button-resolver{
  background-color: #1B8BD9;
  color:#FFFFFF;
  border: 1px solid #1B8BD9;
  border-radius: 5px;
  font-weight: normal;
  font: normal normal 600 11px/15px Open Sans;
}
</style>
